
import {
    Link,
    BrowserRouter as Router,
    Switch as Sw,
    Route
  } from "react-router-dom";
import Home6 from "./home6";
import FAQ from "./pages/faq";


function App(){
    return (
        <div>
            <Router>
                <Sw>
                    <Route exact path="/"><Home6/></Route>
                    <Route exact path="/faq"><FAQ/></Route>
                </Sw>
            </Router>
        </div>
    );
}

export default App;
